import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductTemp } from '../../../common/models/Product.Model'
import { UserLogin } from '../../../common/models/UserLogin.Model';
import { SettingsService } from '../../../../core/settings/settings.service';
import { TaxService } from '../../tax.service';
import {  FormControl, FormGroup,  Validators } from '@angular/forms';
import { ProxyGet } from 'src/app/ceq/common/services/proxy.service';
import { Params, SingleResponseJson } from 'src/app/ceq/common/models/response';
import { Container } from '../../../common/models/Container.Model';
import { LabelService } from 'src/app/ceq/enterprise/label/label.service';
import { GlobalFunctionsService } from 'src/app/ceq/common/functions/global-functions.service';

@Component({
  selector: 'app-certify-product-detail',
  templateUrl: './certify-product-detail.component.html',
  styleUrls: ['./certify-product-detail.component.scss']
})
export class CertifyProductDetailComponent implements OnInit {

    FormProductTemp: FormGroup;
    productCode: string = '';
    disabledArt: boolean = false;
    product: ProductTemp = new ProductTemp();
    user: UserLogin;
    containerList: Container[];
    containerList2: Container[];
  
    constructor(
      private labelService: LabelService,
      private apiService: ProxyGet,
      private settings: SettingsService,
      private taxServices: TaxService,
      private globalFunctionService: GlobalFunctionsService,
      private url: ActivatedRoute) {
        this.FormProductTemp = new FormGroup({
          ProductCode: new FormControl({value: '', disabled: true}, [Validators.required, Validators.pattern('^[0-9]*$')]),
          ProductDescription: new FormControl({value: '', disabled: true}, [Validators.required,Validators.minLength(1), Validators.maxLength(200) ]),
          ProductName:new FormControl({value: '', disabled: true}, [Validators.required,Validators.minLength(1), Validators.maxLength(50) ]),
          ItemPlantaId:new FormControl({value: '', disabled: true}, [Validators.required, Validators.pattern('^[0-9]*$') ]),
          ProductType:new FormControl({value: '', disabled: true}, [Validators.required,Validators.minLength(1), Validators.maxLength(100) ]),
          ProductPrice:new FormControl({value: '', disabled: true}, [Validators.required ]),
          ProductConversion:new FormControl({value: '', disabled: true}, [Validators.required, Validators.pattern('^[0-9]*$') ]),
          ProductWeight:new FormControl({value: '', disabled: true}, [Validators.required, Validators.pattern('^[0-9]*$') ]),
          ProductContainer:new FormControl({value: '', disabled: true}, [Validators.required,Validators.minLength(1), Validators.maxLength(15) ]),
          ProductUom:new FormControl({value: '', disabled: true}, [Validators.required,Validators.minLength(1), Validators.maxLength(15) ]),
          ProductLifeDays:new FormControl({value: '', disabled: true}, [Validators.required, Validators.pattern('^[0-9]*$') ])
        });
        this.productCode = this.url.snapshot.paramMap.get('id');
       }
  
    ngOnInit(): void {
      this.user = this.settings.getUser();
      this.getContainers();
      this.taxServices.getProductTempByCode(this.user.Org, this.productCode).toPromise()
      .then(async (resp:ProductTemp) =>{
        this.product = resp;
        this.FormProductTemp.patchValue({
          ProductDescription: resp.ProductDescription,
          ProductName: resp.ProductName,
          ItemPlantaId: resp.ItemPlantaId,
          ProductType: resp.ProductType,
          ProductPrice: new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(resp.ProductPrice),
          ProductConversion: resp.ProductConversion,
          ProductWeight: resp.ProductWeight,
          ProductCode: resp.ProductCode
        });
        if(this.product.Status == 'R'){
          this.disabledArt = true;
		      await this.globalFunctionService.messageBimbo( "Este producto ya fue removido de los productos temporales", 'warning', '¡Aviso!');
        }
        else{
          this.FormProductTemp.get('ProductDescription')?.enable();  
          this.FormProductTemp.get('ProductName')?.enable();  
          this.FormProductTemp.get('ItemPlantaId')?.enable();  
          this.FormProductTemp.get('ProductType')?.enable();  
          this.FormProductTemp.get('ProductPrice')?.enable();  
          this.FormProductTemp.get('ProductConversion')?.enable();  
          this.FormProductTemp.get('ProductWeight')?.enable(); 
          this.FormProductTemp.get('ProductContainer')?.enable(); 
          this.FormProductTemp.get('ProductUom')?.enable();  
          this.FormProductTemp.get('ProductLifeDays')?.enable(); 
        }
      })
      .catch()
    }

    getContainers() {
      this.labelService.getContainers("Contenedor").subscribe((cont: Container[]) => {
        this.containerList = cont;
      }, async err => {
		    await this.globalFunctionService.messageBimbo('Error al obtener lista de Contenedores, verifique su conexión a internet', 'warning', '¡Alerta!');
      });
      this.labelService.getContainers("Envaces").subscribe((cont: Container[]) => {
        this.containerList2 = cont;
      }, async err => {
		    await this.globalFunctionService.messageBimbo('Error al obtener lista de Envaces, verifique su conexión a internet', 'warning', '¡Alerta!');
      });
    }
  
    async formSubmit(event:any) {
      if (this.FormProductTemp.valid) {
         const request: Params = {
          Parameter: [
            {
              Field: "Codebar",
              Value: this.product.ProductBarcode,
              Object: null
            },
            {
              Field: "ProductContainer",
              Value: this.FormProductTemp.get('ProductContainer').value,
              Object: null
            },
            {
              Field: "ProductUom",
              Value: this.FormProductTemp.get('ProductUom').value,
              Object: null
            },
            {
              Field: "ProductLifeDays",
              Value: this.FormProductTemp.get('ProductLifeDays').value,
              Object: null
            },
            {
              Field: "ProductCode",
              Value: this.FormProductTemp.get('ProductCode').value,
              Object: null
            },
            {
              Field: "ProductDescription",
              Value: this.FormProductTemp.get('ProductDescription').value,
              Object: null
            },
            {
              Field: "ProductName",
              Value: this.FormProductTemp.get('ProductName').value,
              Object: null
            },
            {
              Field: "ItemPlantaId",
              Value: this.FormProductTemp.get('ItemPlantaId').value,
              Object: null
            },
            {
              Field: "ProductType",
              Value: this.FormProductTemp.get('ProductType').value,
              Object: null
            },
            {
              Field: "ProductPrice",
              Value: this.FormProductTemp.get('ProductPrice').value.replace('$','').replace(',',''),
              Object: null
            },
            {
              Field: "ProductConversion",
              Value: this.FormProductTemp.get('ProductConversion').value,
              Object: null
            },
            {
              Field: "ProductWeight",
              Value: this.FormProductTemp.get('ProductWeight').value,
              Object: null
            },
          ]
        };

        const jsonDta = await this.apiService.callAPIWithParams(`Product/updateProductTemp`, "POST", request);
        const response = jsonDta as SingleResponseJson<boolean>;
        if (response && response.Success) {
			await this.globalFunctionService.messageBimbo('El producto fue añadido correctamente', 'success', '¡Éxito!').then(()=>{
            this.btnCancelOnClick();
          });
          
        }else {
			await this.globalFunctionService.messageBimbo(`${response.Error_code}: ${response.Error_msg}`, 'error', '¡Error!');
        };
        
      }else{
		  await this.globalFunctionService.messageBimbo('Es necesario para continuar, llenar todos los campos ', 'warning', '¡Alerta!');
      }
    }

    async delete() {
      const result = await this.globalFunctionService.messageBimbo("¿Desea eliminar el producto del catálogo temporal?", 'question1', 'Confirmación');
      if (result) {
        const request: Params = {
          Parameter: [
            {
              Field: "ProductCode",
              Value: this.FormProductTemp.get('ProductCode').value,
              Object: null
            }
          ]
        };
        const jsonDta = await this.apiService.callAPIWithParams(`Product/removeProductTemp`, "PUT", request);
        const response = jsonDta as SingleResponseJson<boolean>;
        if (response && response.Success) {
          await this.globalFunctionService.messageBimbo('El producto fue removido del catálogo', 'success', '¡Éxito!').then(()=>{
            this.btnCancelOnClick();
          });
          
        }else {
      await this.globalFunctionService.messageBimbo(`${response.Error_code}: ${response.Error_msg}`, 'error', '¡Error!');
        };
      }
    }
    
    btnCancelOnClick(){
      // this.router.navigate(['/tax/product']);
      window.close();
    }
  }
  